import React from 'react';
import {
  Typography,
  Card,
  CardContent,
  CardActions,
  Button,
} from '@mui/material';

interface IFeedItemProps {
  title: string;
  link: string;
  date: string;
  content: string;
}

const FeedItem: React.FC<IFeedItemProps> = (props: IFeedItemProps) => {
  const { title, link, date, content } = props;
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  };
  const formattedDate = new Date(date).toLocaleDateString('en-US', options);
  return (
    <Card className='feed-item' style={{ backgroundColor: 'var(--bg-secondary)' }}>
      <CardContent>
        <Typography variant='h6' style={{ fontSize: '16px', color: 'var(--table-text)' }} >
          {title}
        </Typography>
        <Typography variant='body2' style={{ color: 'var(--table-text)' }}>
          {formattedDate}
        </Typography>
        <br />
        <Typography variant='body2' style={{ color: 'var(--table-text)' }}>
          {content}
        </Typography>
      </CardContent>
      <CardActions>
        <a href={link} target='_blank' rel='noreferrer'>
          <Button style={{ color: '#4895EF' }} size='medium'>
            Read More
          </Button>
        </a>
      </CardActions>
    </Card>
  );
};

export default FeedItem;
